import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface modals {
  showLogin: boolean;
  showRegister: boolean;
  showRecovery: boolean;
  showRecoveryCode: boolean;
  showUserInfo: boolean;
  showBlockedByCheckout: boolean;
  showBlockedInCheckout: boolean;
  fromBuyButton: boolean;
}

const initialState: modals = {
  showLogin: false,
  showRegister: false,
  showRecovery: false,
  showRecoveryCode: false,
  showUserInfo: false,
  showBlockedByCheckout: false,
  showBlockedInCheckout: false,
  fromBuyButton: false,
};

/** Almacena el estado showLoginReducer de Redux con sus reducers
 * @constant {object}
 */
export const showModalsSlice = createSlice({
  name: 'showModals',
  initialState,
  reducers: {
    changeLoginState: (state) => {
      state.showLogin = !state.showLogin;
    },
    changeRegisterState: (state) => {
      state.showRegister = !state.showRegister;
    },
    changeRecoveryState: (state) => {
      state.showRecovery = !state.showRecovery;
    },
    changeRecoveryCodeState: (state) => {
      state.showRecoveryCode = !state.showRecoveryCode;
    },
    changeUserInfoState: (state) => {
      state.showUserInfo = !state.showUserInfo;
    },
    changeBlockedByCheckoutState: (state) => {
      state.showBlockedByCheckout = !state.showBlockedByCheckout;
    },
    changeBlockedInCheckoutState: (state) => {
      state.showBlockedInCheckout = false;
    },
    setFromBuyButton: (state, action: PayloadAction<boolean>) => {
      state.fromBuyButton = action.payload;
    },
    restoreShowModalsState: (_) => ({ ...initialState }),
  },
});

export const {
  changeLoginState,
  changeRegisterState,
  changeRecoveryState,
  changeRecoveryCodeState,
  changeUserInfoState,
  restoreShowModalsState,
  setFromBuyButton,
  changeBlockedByCheckoutState,
  changeBlockedInCheckoutState,
} = showModalsSlice.actions;

export default showModalsSlice.reducer;
